import {createContext} from 'react'

export type RouteInfoCtx = {
  alternativeRoutes?: Record<string, Record<string, string>>
  currentRegion?: string
  currentLocale?: string
}

export default createContext<RouteInfoCtx>({})
